const manutencao_das_vagas_de_dificientes = {
  path: "/manutencao-das-vagas-de-deficiente",
  redirect: "/manutencao-das-vagas-de-deficiente",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção de Vagas",
  },
  children: [
    {
      path: "/manutencao-das-vagas-de-deficiente",
      name: "manutencao_das_vagas_de_deficiente",
      meta: {
        allowedPermissions: ["deficiencia_vaga_atualizar"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDasVagasDeDeficiente/ManutencaoDasVagasDeDeficienteHome.vue"
        ),
    },
  ],
};

export { manutencao_das_vagas_de_dificientes };
